import React, { useState, useEffect, useCallback } from 'react'
import YouTube from 'react-youtube'

import { classes } from '../util/components'
import { getYoutubeVideoID, isYoutubeUrl } from '../util/youtube'
import styles from './cover-image.module.css'
import Image from './image'
import PlayButton from './play-button'

const CoverImage = ({
  videoUrl,
  image,
  title,
  className,
  onTrailerPlay,
  onTrailerPause,
  onTrailerStart,
}) => {
  const [isTrailerStarted, setIsTrailerStarted] = useState(false)
  const [trailerThumbnail, setTrailerThumbnail] = useState()

  const youtubeID =
    videoUrl && isYoutubeUrl(videoUrl) && getYoutubeVideoID(videoUrl)

  useEffect(() => {
    if (!youtubeID) {
      return
    }

    const maxRes = `https://img.youtube.com/vi/${youtubeID}/maxresdefault.jpg`
    const hires = `https://img.youtube.com/vi/${youtubeID}/hqdefault.jpg`

    fetch(maxRes, { method: 'OPTIONS' })
      .then(r => {
        setTrailerThumbnail(maxRes)
      })
      .catch(() => {
        setTrailerThumbnail(hires)
      })
  }, [youtubeID])

  const playTrailer = () => {
    if (!youtubeID) {
      return
    }

    if (onTrailerStart) {
      onTrailerStart()
    }

    setIsTrailerStarted(true)
  }

  const handleStateChange = useCallback(
    e => {
      if (e.data === 1) {
        onTrailerPlay && onTrailerPlay()
      } else if (e.data === 2) {
        onTrailerPause && onTrailerPause()
      }
    },
    [onTrailerPlay, onTrailerPause]
  )

  if (isTrailerStarted) {
    return (
      <YouTube
        videoId={youtubeID}
        className={styles.trailerIframe}
        containerClassName={classes(styles.trailer, className)}
        onStateChange={handleStateChange}
        opts={{
          width: 1280,
          height: 720,
          playerVars: {
            autoplay: 1,
            color: 'white',
          },
        }}
      />
    )
  } else {
    if (image) {
      let imageSrc = image

      if (typeof image === 'object' && image.childImageSharp) {
        imageSrc = image.childImageSharp.fluid
      }

      return (
        <article
          className={`${styles.coverImage} ${className}`}
          onClick={playTrailer}
          style={{
            cursor: youtubeID ? 'pointer' : 'auto',
          }}
        >
          <Image style={{ height: '100%' }} fluid={imageSrc} />
          {youtubeID ? (
            <PlayButton
              aria-label={`Play trailer for ${title}`}
              className={styles.playButton}
            />
          ) : null}
        </article>
      )
    } else if (trailerThumbnail) {
      return (
        <article
          className={`${styles.trailer} ${className}`}
          style={{
            backgroundImage: `url(${trailerThumbnail})`,
            backgroundPosition: 'center',
          }}
          onClick={playTrailer}
        >
          <PlayButton
            aria-label={`Play trailer for ${title}`}
            className={styles.playButton}
          />
        </article>
      )
    }

    return null
  }
}

export default CoverImage
